<ng-container *ngIf="user">
  <app-toolbar [title]="title" [user]="user" [destination]="destination" [back]="back"></app-toolbar>
</ng-container>
<div class="container">
  <main>
    <div #scrollMe class="chat-box" [scrollTop]="scrollMe.scrollHeight">
      <div *ngFor="let mess of messages">
        <div *ngIf="itIsMy(mess)" class="chat-r">
          <div class="sp"></div>
          <div class="mess mess-r">
            <span class="descSender">{{mess.nameSender}} {{mess.surnameSender}}</span>
            <!-- Visualizziamo il testo del messaggio, e lo rendiamo cliccabile nel caso sia un file -->
            <div *ngIf="mess.fileIsPresent == true" class="file" (click)="downloadFile(mess)"><p>{{mess.text}}</p></div>
            <p *ngIf="mess.fileIsPresent == false">{{mess.text}}</p>
            <div class="check">
              <span *ngIf="messages!=undefined">{{mess.date.split("T")[0].split("-")[2]}}/{{mess.date.split("T")[0].split("-")[1]}} &nbsp;&nbsp;&nbsp; {{mess.date.split("T")[1].split(":")[0]}}:{{mess.date.split("T")[1].split(":")[1]}}</span>
            </div>
          </div>
        </div>
        <div *ngIf="!itIsMy(mess)" class="chat-l">
          <div class="mess">
            <span *ngIf="mess.sender != mess.patientEmail" id="dottorSenderLabel" class="descSender">
                <i><b>Dott: </b></i>{{mess.nameSender}} {{mess.surnameSender}}
              </span>
            <!-- Visualizziamo il testo del messaggio, e lo rendiamo cliccabile nel caso sia un file -->
            <div *ngIf="mess.fileIsPresent == true" class="file" (click)="downloadFile(mess)"><p>{{mess.text}}</p></div>
            <p *ngIf="mess.fileIsPresent == false">{{mess.text}}</p>
            <div class="check">
              <span *ngIf="messages!=undefined">{{mess.date.split("T")[0].split("-")[2]}}/{{mess.date.split("T")[0].split("-")[1]}} &nbsp;&nbsp;&nbsp; {{mess.date.split("T")[1].split(":")[0]}}:{{mess.date.split("T")[1].split(":")[1]}}</span>
            </div>
          </div>
          <div class="sp"></div>
        </div>
      </div>
    </div>
  </main>


  <ng-container *ngIf="isMobile ; else isDesktop">
    <footer>
      <mat-card>
        <mat-grid-list id="inputGridMobile" cols="7" rowHeight="fit">
          <mat-grid-tile id="grid1Mobile" [colspan]="5" [rowspan]="1">
            <mat-form-field class="myTextFieldMobile">
              <mat-label>Scrivi qui</mat-label>
              <textarea [(ngModel)]="textSend" matInput></textarea>
            </mat-form-field>
          </mat-grid-tile>
          <!-- qui sotto il bottone per allegare un file e quello per mandare un messaggio-->
          <mat-grid-tile [colspan]="1"  [rowspan]="1">
            <button mat-mini-fab id="attachButtonMobile" color="primary" aria-label="Allega file" (click)="attachFile()">
              <span id="attachIconMobile" class="material-icons">attach_file</span>
            </button>
          </mat-grid-tile>
          <mat-grid-tile id="grid2Mobile" [colspan]="1"  [rowspan]="1">
            <button mat-mini-fab id="sendButtonMobile" color="primary" aria-label="Invia il messaggio" [disabled]="textSend === ''" (click)="sendMessage()">
              <span class="material-icons" id="iconSendMobile">send</span>
            </button>
          </mat-grid-tile>
        </mat-grid-list>
      </mat-card>
    </footer>
  </ng-container>
  <ng-template #isDesktop>
    <footer>
      <mat-card>
        <mat-grid-list id="inputGrid" cols="10" rowHeight="fit">
          <mat-grid-tile id="grid1" [colspan]="8" [rowspan]="1">
            <mat-form-field class="myTextField">
              <mat-label>Scrivi qui</mat-label>
              <textarea [(ngModel)]="textSend" matInput></textarea>
             </mat-form-field>
          </mat-grid-tile>
          <!-- qui sotto il bottone per allegare un file e quello per mandare un messaggio-->
          <mat-grid-tile [colspan]="1"  [rowspan]="1">
            <button mat-fab id="attachButton" color="primary" aria-label="Allega file" (click)="attachFile()">
              <span id="attachIcon" class="material-icons">attach_file</span>
            </button>
          </mat-grid-tile>
          <mat-grid-tile id="grid2" [colspan]="1"  [rowspan]="1">
            <button mat-fab id="sendButton" color="primary" aria-label="Invia il messaggio" [disabled]="textSend === ''" (click)="sendMessage()">
              <span class="material-icons" id="iconSend">send</span>
            </button>
          </mat-grid-tile>
        </mat-grid-list>
      </mat-card>
    </footer>
  </ng-template>
</div>
